import { render, staticRenderFns } from "./recActivity.vue?vue&type=template&id=2376ddae&"
import script from "./recActivity.vue?vue&type=script&lang=js&"
export * from "./recActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports